window.onload = function() {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const token = urlParams.get('token');
  if (token) {
    const iframe = document.getElementById('zru-iframe');
    if (iframe) {
      iframe.src = 'https://pay.mychoice2pay.com/' + token + '/iframe';
      //iframe.style.display = 'block';
    }
  }
};